import { render, staticRenderFns } from "./DefaultSerumCard.vue?vue&type=template&id=b44408a6&scoped=true"
import script from "./DefaultSerumCard.vue?vue&type=script&lang=js"
export * from "./DefaultSerumCard.vue?vue&type=script&lang=js"
import style0 from "./DefaultSerumCard.vue?vue&type=style&index=0&id=b44408a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44408a6",
  null
  
)

export default component.exports